import React from "react";
import "../../LoanEMICalculators.css";
import { Typography, Grid } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";
import { calculatorsData } from "./emiCalculatorsLinks";
import { useNavigate } from "react-router-dom";

const RefinanceCalculators = () => {
  const navigate = useNavigate();

  const handleLoadMore = () => {
    navigate("/calculators/refinancing-calculators");
    window.scrollTo(0, 0);
  };

  return (
    <div className="pages_box__main_container">
      <div className="pages_box__container">
        <div
          className="d-flex flex-column gap-3"
          style={{ backgroundColor: "transparent" }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: 30,
                lg: 35,
                xl: 40,
              },
              fontWeight: 600,
              color: "#59266D",
              lineHeight: { xs: "35px", lg: "40.2px", xl: "49.2px" },
              fontFamily: "Archivo",
              textAlign: "start",
              backgroundColor: "transparent",
            }}
          >
            Refinance Calculators
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              lineHeight: { xs: "20px", sm: "24px" },
              fontWeight: 400,
              color: "#74589B",
              textAlign: "start",
              fontFamily: "Archivo",
              backgroundColor: "transparent",
            }}
          >
            Refinancing can help lower your EMIs, reduce your interest burden,
            and optimize your loan repayment. Use our refinance calculators to
            evaluate how much you can save on different types of loans. Whether
            you're refinancing a car loan or a personal loan, Minemi ensures you
            get the best deals.
          </Typography>
        </div>
        <div className="w-100 mt-5">
          <Grid container spacing={2} style={{ backgroundColor: "#E7E4F9" }}>
            {calculatorsData &&
              calculatorsData.map((item) => {
                const nameParts = item.calculatorName.split(" ");
                const formattedName =
                  nameParts.length > 1
                    ? nameParts.slice(0, -1).join(" ") +
                      " <br /> " +
                      nameParts.slice(-1)
                    : item.calculatorName;

                return (
                  <Grid
                    item
                    key={item.id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    style={{ backgroundColor: "transparent" }}
                  >
                    <div className="calculator_card__box w-100">
                      <div className="w-100">
                        <img
                          src={item.image}
                          alt={item.calculatorName}
                          loading="lazy"
                          className="card_img"
                        />
                      </div>
                      <div className="d-flex flex-row align-items-center justify-content-between pt-2">
                        <p
                          style={{
                            fontSize: 16,
                            color: "#1f1f1f",
                            lineHeight: "20px",
                            fontWeight: 500,
                            fontFamily: "Archivo",
                            textAlign: "start",
                            backgroundColor: "transparent",
                          }}
                          className="calculator_name"
                          dangerouslySetInnerHTML={{ __html: formattedName }}
                        ></p>
                        <span className="icon_box mt-4 p-1 rounded">
                          <ArrowForwardRounded
                            sx={{
                              color: "#59266D",
                              backgroundColor: "transparent",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate(`${item.link}`);
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </Grid>
                );
              })}
          </Grid>
        </div>
      </div>
      <p
        style={{
          fontSize: { xs: 18, md: 21 },
          lineHeight: "25.83px",
          fontWeight: 600,
          fontFamily: "Archivo",
          backgroundColor: "transparent",
          textAlign: "center",
          cursor: "pointer",
        }}
        className="py-3 m-0"
        onClick={handleLoadMore}
      >
        Load more.
      </p>
    </div>
  );
};

export default RefinanceCalculators;
